import { clsx } from 'clsx';
import type { AnchorHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import type {
  LinkProps as RRLinkProps,
  NavLinkProps as RRNavLinkProps,
} from 'react-router-dom';
import { Link as RRLink, NavLink as RRNavLink } from 'react-router-dom';

import styles from './link.module.scss';

export type LinkProps = RRLinkProps & {
  palette?: 'primary' | 'secondary';
};

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, palette = 'primary', ...props }, ref) => (
    <RRLink
      className={clsx(styles.link, className, {
        [styles.linkPrimary]: palette === 'primary',
        [styles.linkSecondary]: palette === 'secondary',
      })}
      ref={ref}
      {...props}
    />
  )
);
Link.displayName = 'Link';

export type NavLinkProps = RRNavLinkProps & {
  palette?: 'primary' | 'secondary';
};

export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ className, palette = 'primary', ...props }, ref) => (
    <RRNavLink
      className={clsx(styles.link, className, {
        [styles.linkPrimary]: palette === 'primary',
        [styles.linkSecondary]: palette === 'secondary',
      })}
      ref={ref}
      {...props}
    />
  )
);
NavLink.displayName = 'NavLink';

export type ExternalLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  palette?: 'primary' | 'secondary';
};

export const ExternalLink = forwardRef<HTMLAnchorElement, ExternalLinkProps>(
  ({ className, palette = 'primary', ...props }, ref) => (
    <a
      className={clsx(styles.link, className, {
        [styles.linkPrimary]: palette === 'primary',
        [styles.linkSecondary]: palette === 'secondary',
      })}
      ref={ref}
      target='_blank'
      rel='noreferrer noopener'
      {...props}
    />
  )
);
ExternalLink.displayName = 'ExternalLink';
